// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".logotype[data-v-38b05100]{width:14rem}@media(max-width:991px){.logotype[data-v-38b05100]{margin:0 auto}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
